module.exports = __webpack_public_path__ + "static/media/cv.df006f17.png";